import { h, Component } from 'preact';
import { sortObjectByOrder } from 'utils/utils';
import s from 'components/bolt/uarFooter/uarFooter.sss';

export default class UarFooter extends Component {

	render({ data }) {
		const copyrights = sortObjectByOrder(data.copyright);
		const links = sortObjectByOrder(data.links);
		const logo = data.logo;

		return (
			<footer class={s.footer}>
				<img class={s.logo} src={logo.src} alt={logo.altText} />
				<div class={s.content}>
					<div class={s.copyrights}>
						{copyrights.map(copyright => {
							return <a class={s.copyright} href={copyright.url} target='_blank'>
								{copyright.$copy}
							</a>;
						})}
					</div>
					<div class={s.links}>
						{links.map(link => {
							let isOneTrust = link.url === '@otcookiesettings';
							return <a
								id={isOneTrust && 'ot-sdk-btn'}
								class={s.link}
								href={!isOneTrust && link.url}
								target='_blank'
								onClick={() => isOneTrust && window.OneTrust.ToggleInfoDisplay()}
							>
								{link.$copy}
							</a>;
						})}
					</div>
				</div>
			</footer>
		);
	}
}
